export type ShortCriteriaBase = {
  alertId: number;
  alertGroupId: number;
  // TODO: `alertExpression` should be removed when BE is fixed
  alertExpression: string;
};

export type FullCriteriaBase = ShortCriteriaBase & {
  alertCriteriaId: number;
  updateTimestamp: string | null;
  insertTimestamp: string | null;
};

/**
 * All fields are dynamic and should be generated from:
 * `src/components/ProductAlerts/AlertConfiguration/BlockContent/AlertCriteria/alertCriteriaConfig.json`
 */
export type CriteriaValue = {
  criteriaType: string;
  criteriaTypeOptions: string;
  sourceOwnerId: string;
  // TODO: we should move typings into the JSON itself
  competitorOwnerId: string[];
  regionId: string;
  soldBy: string;
  fulfilledBy: string;
  operator: string;
  value: number;
  unit: string;
};

export type FullCriteria = FullCriteriaBase & CriteriaValue;
export type PartialCriteria = FullCriteriaBase & Partial<CriteriaValue>;

export type NewCriteria = Partial<CriteriaValue> & { operation: 'add' };
export type UpdatedCriteria = PartialCriteria & { operation: 'update' };
export type DeletedCriteria = PartialCriteria & { operation: 'del' };
export type CriteriaListItem = FullCriteria & { operation: null };

export type AnyCriteria = NewCriteria | UpdatedCriteria | CriteriaListItem;

export const isNewCriteria = (v: AnyCriteria): v is NewCriteria => {
  return v.operation === 'add';
};

export const isUpdatedCriteria = (v: AnyCriteria): v is UpdatedCriteria => {
  return v.operation === 'update';
};

/**
 * All fields are dynamic and should be generated from:
 * `src/components/ProductAlerts/AlertConfiguration/BlockContent/AlertCriteria/alertCriteriaConfig.json`
 */
export const getCriteriaValueKeys = (): (keyof CriteriaValue)[] => {
  return [
    'criteriaType',
    'criteriaTypeOptions',
    'sourceOwnerId',
    'competitorOwnerId',
    'regionId',
    'soldBy',
    'fulfilledBy',
    'operator',
    'value',
    'unit',
  ];
};

export namespace AlertCriteria {
  type AddingCriteria = ShortCriteriaBase & Required<NewCriteria>;
  type UpdatingCriteria = Required<UpdatedCriteria>;
  type DeletingCriteria = Required<DeletedCriteria>;

  export type RequestBody = Array<AddingCriteria | UpdatingCriteria | DeletingCriteria>;
}
